import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { UserReport } from '@/domain/entities/UserReport'
import router from '@/router'
import Vue from 'vue'
import { UserReportPresenter } from '@/app/ui/presenters/UserReportPresenter'
import { AuthModule } from './auth'

export interface UserState {
  userData: UserReport
  isLoading: boolean
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'userlists' })
class Users extends VuexModule implements UserState {
  public isLoading = true
  public userData = new UserReport(true, '')
  public paginationParam = {
    filter: {
      salescode: '',
      team: '',
      position: '',
      dealercode: '',
      dealergroup: '',
      active: '',
      statusRegistration: '',
      typeSales: '',
      dealerarea: '',
      dealername: '',
      city: '',
      branch: '',
      start: '',
      end: '',
    },
  }

  @Action
  public async getUserData() {
    this.setLoading(true)
    const presenter = await container.resolve(UserReportPresenter)
    presenter
      .loadUserReport(this.paginationParam)
      .then((res: UserReport) => {
        this.setLoading(false)
        this.setUserData(res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
      })
  }

  @Mutation
  private setUserData(user: UserReport) {
    this.userData = user
  }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
}

export const UserReportModule = getModule(Users)
